export const website = {
  loaded: false
};